// @flow
import * as React from 'react';
import { Box } from 'grommet';
import styled from 'styled-components';
import Presence from 'esm-web-pro/containers/panels/calling/presence/Presence';


type Props = {
    children: React.Node,
};

export const StyledPresenceBox = styled(Box)`
    border: solid ${(props) => props.presenceColor} 2px;
    border-radius: 6px;
    width: 33px;
    height: 33px;
    align-items: center;
    align-content: center;
    flex-shrink: 0;
`;

const PresenceBox = (props: Props) => {
    const { children } = props;
    return (
        <Presence>
            {(presence) => (
                <StyledPresenceBox presenceColor={presence}>
                    {children}
                </StyledPresenceBox>
            )}
        </Presence>
    );
};

export default PresenceBox;
